import { controls, currencyToNumber, grouped } from "../../controls";

const girl_child_count = {
  label: "Girl Child Count",
  starting: true,
  url: "girl_child_count",
  pageLabel: "Girl Child Count",
  pageType: "history",

  // filteraction: true,
  filter: [
    ...controls.displayText({ tab: "filter", label: "Child Status" }),
    ...controls.autoComplete({ tab: "filter", name: "child_status_code", width: "col-sm-4", controlType: "ChildStatus" }),

  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Girl Child Count",
    filterable: true,
    sortable: true,
    pivotable: true,
    defaultsTo: 0,
    pdfProps: {
      pageSize: "A4", pageOrientation: "portrait",
    },
    pivot: true,
    extraRows: {
      location: "top",
      fields: ["count"],
      subtotals: {
        by: "taluka_display",
        displayIn: "village_display",
        subtotals: {
          by: "area_type_display",
          displayIn: "village_display",
        },
      },
      grandtotal: { type: "fixed", displayIn: "village_display", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Village/Ward",
        accessor: "village_display"
      },

      {
        Header: "Girl Child Count ",
        accessor: "count",
        rwidth: "*",


      }


    ]
  }
};

export default girl_child_count;